import { ReduceStore } from 'flux/utils';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

class LastAuthenticationAttemptStore extends ReduceStore {
  getInitialState() {
    return {
      success: null,
      message: '',
    };
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.USER_AUTHENTICATED:
        return {
          success: true,
          message: '', 
        };
      case Constants.USER_AUTHENTICATION_FAILED:
        return {
          success: false,
          message: action.authErr.errorDescription,
        };
      default:
        return state;
    }
  }
}

const instance = new LastAuthenticationAttemptStore(AppDispatcher);
export default instance;
